import { imagePath } from 'utils/helpers';

const defaultAttributes = {
  banner_image_desktop: `${imagePath}/images/explore/OWNBanner_desktop.png`,
  banner_image_tablet: `${imagePath}/images/explore/OWNBanner_tablet.png`,
  banner_image_mobile: `${imagePath}/images/explore/OWNBanner_mobile.png`,
  banner_image_ios: `${imagePath}/images/explore/OWNBanner_mobile.png`,
  banner_title_desktop: 'RAISE FROM THE CROWD',
  banner_title_tablet: 'RAISE FROM THE CROWD',
  banner_title_mobile: 'Raise From The Crowd',
  banner_title_ios: 'Raise From The Crowd',
  banner_subtitle_desktop: `Join 1,000 founders who've raised capital on StartEngine.`,
  banner_subtitle_tablet: `Join 1,000 founders who've raised capital on StartEngine.`,
  banner_subtitle_mobile: `Join 1,000 founders who've raised capital on StartEngine.`,
  banner_subtitle_ios: `Join 1,000 founders who've raised capital on StartEngine.`,
  banner_button_text_desktop: 'Apply Now',
  banner_button_text_tablet: 'Apply Now',
  banner_button_text_mobile: 'Apply Now',
  banner_button_text_ios: 'Apply Now',
  banner_button_url_desktop: 'https://www.startengine.com/raise-capital',
  banner_button_url_tablet: 'https://www.startengine.com/raise-capital',
  banner_button_url_mobile: 'https://www.startengine.com/raise-capital',
  banner_button_url_ios: 'https://www.startengine.com/raise-capital',
  banner_disclaimer_desktop: ``,
  banner_disclaimer_tablet: ``,
  banner_disclaimer_mobile: ``,
  banner_disclaimer_ios: ``,
};

export default defaultAttributes;
